import React, { type JSX, useEffect } from 'react';
import App from './App';
import AppRouter from './AppRouter';
import { initGlobalErrorHandlers } from './lib/globalErrorHandler.ts';

const AppHookContainer = (): JSX.Element => {
  useEffect(() => {
    initGlobalErrorHandlers();
  }, []);

  return (
    <App>
      <AppRouter />
    </App>
  );
};

export default AppHookContainer;
